/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Save_TitleInputs */

const en_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Style Preset`)
};

const fr_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le prereglage de style`)
};

const de_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stilvoreinstellung speichern`)
};

const it_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva stile predefinito`)
};

const ru_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить предустановку стиля`)
};

const es_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar estilo preestablecido`)
};

const zh_cn2_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存样式预设`)
};

const ja_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルプリセットを保存`)
};

const hi_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल प्रीसेट सहेजें`)
};

const pt_pt2_image_export_style_preset_save_title = /** @type {(inputs: Image_Export_Style_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar predefinição de estilo`)
};

/**
* | output |
* | --- |
* | "Save Style Preset" |
*
* @param {Image_Export_Style_Preset_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_save_title = /** @type {((inputs?: Image_Export_Style_Preset_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_save_title(inputs)
	if (locale === "de") return de_image_export_style_preset_save_title(inputs)
	if (locale === "it") return it_image_export_style_preset_save_title(inputs)
	if (locale === "ru") return ru_image_export_style_preset_save_title(inputs)
	if (locale === "es") return es_image_export_style_preset_save_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_save_title(inputs)
	if (locale === "ja") return ja_image_export_style_preset_save_title(inputs)
	if (locale === "hi") return hi_image_export_style_preset_save_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_save_title(inputs)
	return en_image_export_style_preset_save_title(inputs)
});